import _OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import globeOutlineIcon from '../../../assets/images/bfg/globe-outline.svg';
import CountdownCard from './countdown-card';
import MavDetailsCard from './mav-details-card';
import MavWhyCard from './mav-why-card';
import Progression from './progression';
import Sponsors from './sponsors';
function MavHome({
  Button,
  challenge,
  defaultParticipationGroup,
  event,
  highlightRegisterCta,
  isMember,
  onRegisterClick
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    paddingY: 3,
    sx: {
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@800': 'row'
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 'calc(100% - 344px)'
    }
  }, event.period === 'future' && /*#__PURE__*/React.createElement(CountdownCard, {
    Button: Button,
    highlightRegisterCta: highlightRegisterCta,
    isMember: isMember,
    onRegisterClick: onRegisterClick,
    startDate: event.startDate
  }), /*#__PURE__*/React.createElement(MavDetailsCard, {
    challenge: challenge
  }), /*#__PURE__*/React.createElement(MavWhyCard, null), /*#__PURE__*/React.createElement(Progression, {
    event: event
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    width: {
      '@': '100%',
      '@800': 320
    }
  }, /*#__PURE__*/React.createElement(Sponsors, {
    defaultParticipationGroup: defaultParticipationGroup,
    event: event
  }), event.dedicatedWebsiteUrl && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    component: "a",
    display: "flex",
    href: event.dedicatedWebsiteUrl,
    justifyContent: "space-between",
    padding: 3,
    rel: "noreferrer",
    sx: {
      textDecoration: 'none'
    },
    target: "_blank"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    height: 16,
    src: globeOutlineIcon,
    width: 16
  }), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      color: '#326ac2',
      fontSize: 16,
      fontWeight: 600
    },
    variant: "body2"
  }, event.dedicatedWebsiteUrl.replace('https://', '').replace('http://', ''))), /*#__PURE__*/React.createElement(_OpenInNewOutlined, {
    sx: {
      color: '#666a6f',
      fontSize: 16
    }
  })))));
}
export default MavHome;